export default "__VITE_ASSET__Cpnst8kh__"